import React from 'react'
import { questionModalMetadata, requestedDocumentModalMetadata } from 'common/constants/firms'
import { AddItemInputProps } from './types';
import FormInput from '../RequestItemModalContent/FormInput'

const AddItemInput = ({
  isDocumentRequest,
  formValues,
  setFormValues,
  setIsMaxCharactersError,
}: AddItemInputProps) => {
  const formStructure = isDocumentRequest ? requestedDocumentModalMetadata : questionModalMetadata;

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormValues({
      ...formValues,
      [e.target.name]: e.target.value,
    });
  };
    
  return (<>
    {isDocumentRequest && (
      <FormInput
        name="name"
        label={formStructure.name}
        placeholder={formStructure.namePlaceholder}
        value={formValues.name}
        handleInputChange={handleInputChange}
        maxCharacters={100}
        setIsMaxCharactersError={setIsMaxCharactersError}
        focusOnMount
      />
    )}
  </>)
}

export default AddItemInput